import React from 'react'
import { Tooltip } from 'antd'
import classNames from 'classnames'
import './MenuItem.scss'
import remixiconUrl from 'remixicon/fonts/remixicon.symbol.svg'

export default function MenuItem({
  icon, title, action, disabled, isActive = null, visible = true
}) {

  if (!visible) {
    return null
  }

  return (
    <Tooltip title={title}>
      <button
        className={classNames(`menu-item`, {'is-active': isActive && isActive(), disabled })}
        onClick={action}
        disabled={disabled}
        type='button'
        >
        <svg className="remix">
          <use xlinkHref={`${remixiconUrl}#ri-${icon}`} />
        </svg>
      </button>
    </Tooltip>
  )
};
